import type { Locale } from '@/lib/i18n/core';

const fr = {
  eyebrow: 'L’ambition prend vie',
  description: 'Vendre, piloter, grandir, faire équipe avec l’IA. Des solutions sur mesure, un univers pour chaque ambition.',
  choose: 'Choisissez votre priorité',
  descriptions: {
    rise: 'Accueillir, orienter et qualifier vos publics, vendre ou animer vos communautés grâce à des parcours personnalisés.',
    'r-node': 'Organiser et piloter votre activité en reliant clients, fournisseurs, équipes et opérations métier.',
    'sx-business': 'Structurer votre croissance : clarifier votre positionnement, renforcer vos offres et optimiser votre modèle économique.',
    elina: 'Intégrer des compétences d’IA à votre activité : vente, assistance technique, maintenance, formation et aide au pilotage.',
  },
  scroll: 'Défilez pour explorer',
  gallery: 'Explorer les quatre univers en images',
  show: 'Afficher',
  previous: 'Image précédente',
  next: 'Image suivante',
  pause: 'Mettre les animations en pause',
  play: 'Animer la galerie',
  progress: 'Votre ambition. Notre engagement.',
  chapters: ['Créer la relation.', 'Relier votre activité.', 'Dessiner la suite.', 'Faire équipe avec l’IA.'],
};
export const PORTAL_COPY: Record<Locale, typeof fr> = {
  fr,
  en: {
    eyebrow: 'Ambition comes to life',
    description: 'Sell, manage, grow, work with AI. Tailored solutions, a world for every ambition.',
    choose: 'Choose your priority', scroll: 'Scroll to explore', gallery: 'Explore our four worlds in pictures', show: 'Show',
    descriptions: {
      rise: 'Welcome, guide and qualify your audiences, sell or engage your communities through personalised journeys.',
      'r-node': 'Organise and manage your business by connecting customers, suppliers, teams and day-to-day operations.',
      'sx-business': 'Structure your growth: clarify your positioning, strengthen your offers and optimise your business model.',
      elina: 'Bring AI skills into your business: sales, technical assistance, maintenance, training and management support.',
    },
    previous: 'Previous image', next: 'Next image', pause: 'Pause animations', play: 'Animate the gallery',
    progress: 'Your ambition. Our commitment.',
    chapters: ['Build relationships.', 'Connect your business.', 'Shape what’s next.', 'Team up with AI.'],
  },
  es: {
    eyebrow: 'La ambición cobra vida',
    description: 'Vender, gestionar, crecer, trabajar con la IA. Soluciones a medida, un universo para cada ambición.',
    choose: 'Elija su prioridad', scroll: 'Desplace para explorar', gallery: 'Explore los cuatro universos en imágenes', show: 'Mostrar',
    descriptions: {
      rise: 'Acoger, orientar y cualificar a sus públicos, vender o dinamizar sus comunidades con recorridos personalizados.',
      'r-node': 'Organizar y dirigir su actividad conectando clientes, proveedores, equipos y operaciones de su negocio.',
      'sx-business': 'Estructurar su crecimiento: clarificar su posicionamiento, reforzar sus ofertas y optimizar su modelo de negocio.',
      elina: 'Integrar competencias de IA en su actividad: ventas, asistencia técnica, mantenimiento, formación y apoyo a la gestión.',
    },
    previous: 'Imagen anterior', next: 'Imagen siguiente', pause: 'Pausar las animaciones', play: 'Animar la galería',
    progress: 'Su ambición. Nuestro compromiso.',
    chapters: ['Crear relaciones.', 'Conectar su actividad.', 'Diseñar el futuro.', 'Trabajar con la IA.'],
  },
  ru: {
    eyebrow: 'Ваши стремления оживают',
    description: 'Продавать, управлять, расти, работать с ИИ. Индивидуальные решения для каждой цели.',
    choose: 'Выберите свой приоритет', scroll: 'Прокрутите, чтобы узнать больше', gallery: 'Четыре направления в изображениях', show: 'Показать',
    descriptions: {
      rise: 'Встречать и направлять аудиторию, уточнять запросы, продавать и развивать сообщества через персональные сценарии.',
      'r-node': 'Организовать бизнес и управлять им, связывая клиентов, поставщиков, команды и рабочие процессы.',
      'sx-business': 'Выстроить рост: уточнить позиционирование, усилить предложения и оптимизировать бизнес-модель.',
      elina: 'Применять ИИ в продажах, технической поддержке, обслуживании, обучении и управлении бизнесом.',
    },
    previous: 'Предыдущее изображение', next: 'Следующее изображение', pause: 'Приостановить анимацию', play: 'Включить анимацию',
    progress: 'Ваши стремления. Наша ответственность.',
    chapters: ['Развивать отношения.', 'Объединять процессы.', 'Определять будущее.', 'Работать с ИИ.'],
  },
};
